import Navbar from '../component/Navbar';
import Footer from '../component/Footer';

const galleryGroups = [
  {
    title: 'Award Distribution Ceremony',
    description: 'Certificate moments, group portraits, and stage memories from the latest AI Sanctuary event.',
    images: [
      'faizann.jpeg',
      'gal1.jpeg',
      'WhatsApp Image 2026-07-08 at 11.46.27 AM.jpeg',
      'gal2.jpeg',
      'WhatsApp Image 2026-07-08 at 11.48.05 AM.jpeg',
      'WhatsApp Image 2026-07-08 at 11.51.15 AM.jpeg',
      'gal3.jpeg',
      'gal4.jpeg',
      'gal5.jpeg',
      'WhatsApp Image 2026-07-08 at 12.25.08 PM.jpeg',
    ],
  },
  {
    title: '3-Day Skill Challenge',
    description: 'Highlights from the challenge, participant moments, and event snapshots.',
    images: ['faizan.png', 'ga1.png', 'ga2.png', 'ga3.png', 'ga4.png', 'ga5.png', 'ga6.png'],
  },
];

function GalleryTile({ src, title, index }) {
  const imagePath = `${process.env.PUBLIC_URL}/images/${src}`;

  return (
    <div className="group relative h-[260px] overflow-hidden rounded-xl bg-[#162D66] shadow-sm sm:h-[300px] lg:h-[320px]">
      <div
        className="absolute inset-0 scale-110 bg-cover bg-center blur-xl transition-transform duration-500 group-hover:scale-125"
        style={{ backgroundImage: `url("${imagePath}")` }}
      />
      <div className="absolute inset-0 bg-[#081430]/35" />
      <img
        src={imagePath}
        alt={`${title} ${index + 1}`}
        className="relative z-10 h-full w-full object-contain transition-transform duration-500 group-hover:scale-[1.02]"
        loading="lazy"
      />
    </div>
  );
}

export default function Gallery() {
  return (
    <div className="bg-white">
      <Navbar />

      <main>
        <section className="relative overflow-hidden px-4 py-12 sm:px-8 lg:px-[80px] lg:py-16">
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(135deg, #E8EEFF 0%, #F5F8FF 52%, #FFFFFF 100%)',
            }}
          />
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/images/bgline.svg`}
              alt=""
              className="absolute left-[8%] top-[-18%] h-[135%] w-[115%] object-contain opacity-80"
            />
          </div>

          <div className="relative z-10 mx-auto max-w-[1080px]">
            <div className="max-w-[740px]">
              <p
                className="mb-3 text-[13px] font-bold uppercase text-[#0F7FDE]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.08em' }}
              >
                AI Sanctuary Gallery
              </p>
              <h1
                className="text-[36px] font-bold leading-[1.1] text-[#162D66] sm:text-[48px] lg:text-[64px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                Overall Events Gallery
              </h1>
              <p
                className="mt-5 max-w-[650px] text-[17px] leading-[28px] text-[#5A666E] sm:text-[20px] sm:leading-[32px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                A complete photo collection from AI Sanctuary event detail pages, including award ceremonies and skill challenges.
              </p>
            </div>
          </div>
        </section>

        <section className="px-4 py-12 sm:px-8 lg:px-[80px] lg:py-16">
          <div className="mx-auto flex max-w-[1080px] flex-col gap-14">
            {galleryGroups.map((group) => (
              <div key={group.title}>
                <div className="mb-6 max-w-[760px]">
                  <h2
                    className="text-[28px] font-semibold leading-[1.15] text-[#162D66] sm:text-[38px]"
                    style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                  >
                    {group.title}
                  </h2>
                  <p
                    className="mt-3 text-[16px] leading-[26px] text-[#5A666E] sm:text-[18px]"
                    style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                  >
                    {group.description}
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {group.images.map((src, index) => (
                    <GalleryTile key={`${group.title}-${src}`} src={src} title={group.title} index={index} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
